import React from "react";
import AppRoutes from "../routes";
import HomePage from "../pages/skinefit/home_page";
import About from "../pages/skinefit/about_page";

const SkinefitTemplate = () => {
  return (
    <>
      <div className="bg-[#F0F4FE] min-h-screen">
        <AppRoutes homePage={HomePage} aboutPage={About} />
      </div>
    </>
  );
};

export default SkinefitTemplate;
